import { useField } from 'formik';
import React, { memo, useCallback, useState } from 'react'
import styled from 'styled-components';
import { cherryRed } from '../../constants/colors';
import CoconutIcon from './CoconutIcon';

const Styles = styled.table`
    cursor: pointer;
`

const IconStyles = styled.span`
    border-radius: 50%;
    padding: 5px;
    margin: 5px;
    color: black;
    text-align: center;
    cursor: pointer;
    font-size: 20px;

    @media (max-width: 480px) {
        padding: 2px;
        margin: 2px;
        svg {
            height: 28px !important;
            width: 28px !important;
        }
    }
`

const SelectableIcon = memo(({ selected, ...props }) =>
    <IconStyles {...props}>
        <CoconutIcon
            height='40px'
            color={selected ? 'white' : 'black'}
            circleHighlight={selected ? cherryRed : null}
        />
    </IconStyles>
)

export const NumberRating = memo(function NumberRating({ value, handleChange, min=1, max=5 }) {
    const [tempValue, setTempValue] = useState(null)
    const values = []
    for (let i=min; i<=max; i++) { values.push(i) }

    const isSelected = val => {
        if (!!tempValue) return tempValue >= val
        if (!!value) return value >= val
        return false
    }

    return <Styles>
        <tbody>
        <tr>
        {values.map(val => <td key={val}
            onClick={() => handleChange(val == value ? undefined : val)}
            onMouseEnter={() => setTempValue(val)}
            onMouseLeave={() => setTempValue(null)}
        >
            <SelectableIcon selected={isSelected(val)}/>
        </td>)}
        </tr>
        </tbody>
    </Styles>
})

export default function RatingField({ name, ...rest }) {
    if (!name) throw Error('"name" required')
    const [{ value }, , { setValue }] = useField(name)
    const handleChange = useCallback(val => setValue(val), [setValue])
    return <div>
        <NumberRating value={value} handleChange={handleChange} {...rest}/>
    </div>
}